import { useMemo } from "react";
import { Provider } from "react-redux";
import SmsModalButton from "./SmsModalButton";

const SmsModalButtonApp = (props) => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <SmsModalButton {...props} />
    </Provider>
  );
};

export default SmsModalButtonApp;
